import { Box } from '@mui/material'
import { ENTRY_SETTINGS_FREQUENCY } from 'agriAdministration/constants/AgriConstants'
import React from 'react'
import i18n from 'simple-react-i18n'

const getSquare = (color, isLast) => {
    return (
        <div
            style={{
                backgroundColor: color || 'white',
                display: 'inline-block',
                width: '20px',
                height: '20px',
                border: 'solid black 1px',
                borderRight: isLast ? 'solid black 1px' : '',
            }}
        >&nbsp;</div>
    )
}

const setTableIndex = (table) => table.map((d, i) => ({ ...d, index: i }))

const getDayDisplay = (value, slotsDisplay, colors) => {
    if (value === '' || value) {
        const slots = value.split('')
        return slotsDisplay.map((i) => {
            return getSquare(colors[slots[i]]?.color, i === slotsDisplay.length - 1)
        })
    }
    return [getSquare('white', true)]
}

const toolFunctions = [
    {
        code: 0,
        name: 'Semaine hors week-end',
        days: ['day1', 'day2', 'day3', 'day4', 'day5'],
    }, {
        code: 1,
        name: 'Week-end',
        days: ['day6', 'day7'],
    }, {
        code: 2,
        name: 'Semaine entière',
        days: ['day1', 'day2', 'day3', 'day4', 'day5', 'day6', 'day7'],
    }, {
        code: 3,
        name: 'Tous les lundis',
        days: ['day1'],
    }, {
        code: 4,
        name: 'Tous les mardis',
        days: ['day2'],
    }, {
        code: 5,
        name: 'Tous les mercredis',
        days: ['day3'],
    }, {
        code: 6,
        name: 'Tous les jeudis',
        days: ['day4'],
    }, {
        code: 7,
        name: 'Tous les vendredis',
        days: ['day5'],
    }, {
        code: 8,
        name: 'Tous les samedis',
        days: ['day6'],
    }, {
        code: 9,
        name: 'Tous les dimanches',
        days: ['day7'],
    },
]

const getApplyDays = (selectionTool, colorInput) => {
    const tool = toolFunctions.find(d => d.code === selectionTool)
    return tool.days.reduce((acc, day) => ({
        ...acc,
        [day]: colorInput,
    }), {})
}

const getTextSlot = (waterTurnSlots) => {
    const slots = waterTurnSlots?.slots?.split('/')
    return slots && slots.map((slot => {
        const hours = slot?.split('-')
        return hours.map(hour => `${hour}h`).join('-') || ''
    })).join('  ') || i18n.notDefined
}

const getEntryFrequencyList = () => [{
    value: ENTRY_SETTINGS_FREQUENCY.WEEKLY,
    label: i18n.weekly,
}, {
    value: ENTRY_SETTINGS_FREQUENCY.MONTHLY,
    label: i18n.monthlyF,
}]

const servicesHeaders = ['codification', 'productCode', 'occurency', 'unity', 'quantity', 'siret', 'codifOCTAGRI', 'folder', 'cityCode', 'city']

const getHydroSituationColor = (color) => {
    switch (color) {
        case 'black':
            return '#000'
        case 'pink':
            return '#FFC0CB'
        case 'magenta':
            return '#FF00FF'
        case 'red':
            return '#FF0000'
        case 'indianred':
            return '#CD5C5C'
        case 'brown':
            return '#A52A2A'
        case 'orange':
            return '#FFA500'
        case 'yellow':
            return '#FFFF00'
        case 'lightyellow':
            return '#FFFFE0'
        case 'white':
            return '#FFF'
        case 'lightgreen':
            return '#90EE90'
        case 'limegreen':
            return '#32CD32'
        case 'darkgreen':
            return '#006400'
        case 'lightblue':
            return '#ADD8E6'
        case 'deepskyblue':
            return '#00BFFF'
        case 'darkblue':
            return '#00008B'
        case 'purple':
            return '#800080'
        case 'darkmagenta':
            return '#8B008B'
        case 'grey':
            return '#808080'
        default:
            return i18n.unknown
    }
}

const getLevelLabel = (level) => {
    switch (level) {
        case 'darkblue': case '#4400F6':
            return i18n.veryHigh
        case 'deepskyblue': case '#3E66ED':
            return i18n.high
        case 'darkgreen': case '#34FFFB':
            return i18n.slightlyHigh
        case 'limegreen': case '#48FF24':
            return i18n.medium
        case 'yellow': case '#F7FF28':
            return i18n.slightlyLow
        case 'orange': case '#F6BD1B':
            return i18n.low
        case 'red': case '#F21007':
            return i18n.veryLow
        default:
            return i18n.unknown
    }
}

const trendEvolution = {
    UP: 'up',
    RIGHT: 'right',
    DOWN: 'down',
}

const getTrendLabel = (level) => {
    switch (level) {
        case trendEvolution.UP:
            return i18n.improvement
        case trendEvolution.RIGHT:
            return i18n.stagnation
        case trendEvolution.DOWN:
            return i18n.degradation
        default:
            return i18n.unknown
    }
}

const getTrendIcon = (level, color) => {
    switch (level) {
        case trendEvolution.UP:
            return <Box padding={0.8} bgcolor={color} sx={{ clipPath: 'polygon(0 100%, 50% 0, 100% 100%)' }} />
        case trendEvolution.RIGHT:
            return <Box padding={0.8} bgcolor={color} />
        case trendEvolution.DOWN:
            return <Box padding={0.8} bgcolor={color} sx={{ clipPath: 'polygon(0 0, 50% 100%, 100% 0)' }} />
        default:
            return undefined
    }
}

export {
    getDayDisplay,
    toolFunctions,
    getSquare,
    getApplyDays,
    setTableIndex,
    getTextSlot,
    getEntryFrequencyList,
    servicesHeaders,
    getHydroSituationColor,
    getLevelLabel,
    trendEvolution,
    getTrendLabel,
    getTrendIcon,
}
